// extracted by css-extract-rspack-plugin
export default {"cls1":"MobileChipize-cls1_Rqh","cls2":"MobileChipize-cls2_ABE MobileChipize-cls1_Rqh","active":"MobileChipize-active_1cj"};